<template>
    <td-table
        :ref="gridRef"
        :height="height"
        :columns="columns"
        :dataSource="currentValue"
        :hasIndex="false"
        :hasPage="false"
        :hasLoading="false"
        :hasMutiSelect="hasMutiSelect"
        @select="_handleSelect"
        @select-all="_handleSelectAll"
    ></td-table>
</template>
<script>
export default {
    props: {
        // 接收列数据信息 包括prop/label/width
        columns: {
            type: Array,
            default: () => []
        },
        /* 是否加载多选框 */
        hasMutiSelect: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /*  表格高度 */
        height: {
            type: [Number, String]
        },
        /* 数据 */
        value: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 接口名称
        url: {
            type: String,
            default: function() {
                return '';
            }
        },
        // 接口请求参数
        urlParam: {
            type: [Number, String, Array, Object],
            default: function() {
                return null;
            }
        },
        //接口请求类型
        requestType: {
            type: String,
            default: function() {
                return 'POST';
            }
        }
    },
    data() {
        return {
            currentValue: []
        };
    },
    created() {
        this._initData();
    },
    watch: {
        value(newVal) {
            this.currentValue = newVal;
        }
    },
    methods: {
        /* 初始化显示数据 */
        _initData() {
            if (this.url != '') {
                this._queryHttp();
            } else {
                this.currentValue = this.value;
            }
        },
        // 请求后台接口
        _queryHttp() {
            let param = {
                ...this.urlParam
            };
            if (this.requestType === 'GET') {
                window.vue.$apiAxios.get(this.url, param, response => {
                    if (response.status !== this.$common.login.RESPONSE_STATUS) {
                        return;
                    }
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        return;
                    }
                    this.value = JSON.parse(JSON.stringify(response.data.content));
                });
            } else {
                window.vue.$apiAxios.postRequestBody(this.url, param, response => {
                    if (response.status !== this.$common.login.RESPONSE_STATUS) {
                        return;
                    }
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        return;
                    }
                    this.value = JSON.parse(JSON.stringify(response.data.content));
                });
            }
        },
        /* 选择后实时回调父组件，selection所有选择行信息，row最新选中行信息 */
        _handleSelect(selection, row) {
            let children = this.$util.isEmpty(this.treeProps) ? row.children : this.$util.isEmpty(this.treeProps.children) ? row.children : row[this.treeProps.children];
            if (!this.$util.isEmpty(children) && children.length > 0) {
                let nowSelect = [];
                nowSelect.push(row);
                nowSelect.push.apply(nowSelect, this.getSelection(children));
                let i = 0;
                nowSelect.forEach(data => {
                    let index = this.multipleSelection.indexOf(data);
                    if (index == -1) {
                        i = i + 1;
                    } else {
                        this.multipleSelection.splice(index, 1);
                    }
                });
                if (i > 0) {
                    this.multipleSelection.push.apply(this.multipleSelection, nowSelect);
                }
            } else {
                this.multipleSelection = selection;
            }
            this.$refs[this.gridRef].clearSelection();
            selection = this.multipleSelection;
            if (!this.$util.isEmpty(selection) && selection.length > 0) {
                selection.forEach(data => {
                    this.$refs[this.gridRef].toggleRowSelection(data, true);
                });
                this.isSelectAll = false;
            } else {
                this.isSelectAll = true;
            }
            this._changePageCoreRecordData();
            this.$emit('handleSelect', selection, row);
            console.log('_handleSelect', selection);
        },
        /* 选择后实时回调父组件，selection所有选择行信息 */
        _handleSelectAll(selection) {
            if (this.isSelectAll || this.multipleSelection.length == 0) {
                this.isSelectAll = false;
                selection = this.getSelection(selection);
                selection.forEach(data => {
                    this.$refs[this.gridRef].toggleRowSelection(data, true);
                    this.multipleSelection.push(data);
                });
            } else {
                this.isSelectAll = true;
                this.$refs[this.gridRef].clearSelection();
                this.multipleSelection = [];
                selection = [];
            }

            this.multipleSelection = selection;
            this._changePageCoreRecordData();
            this.$emit('handleSelectAll', selection);
            console.log('_handleSelectAll', selection);
        }
    }
};
</script>
